import { CareComment } from "./CareComment";
import { CareRecipientId } from "../care_recipient/CareRecipientId";
import { DateTime } from "../fundamental/DateTime";
import { CareCommentThreadId } from "./CareCommentThreadId";

const CareCommentThreadType = Symbol();

export class CareCommentThread {
    [CareCommentThreadType]: any;
    readonly id: CareCommentThreadId;
    readonly careRecipientId: CareRecipientId;
    readonly createdTime: DateTime;
    readonly careComments: CareComment[];
    readonly isPinned: boolean;

    private constructor(
        id: CareCommentThreadId,
        careRecipientId: CareRecipientId,
        createdTime: DateTime,
        careComments: CareComment[],
        isPinned: boolean
    ) {
        this.id = id;
        this.careRecipientId = careRecipientId;
        this.createdTime = createdTime;
        this.careComments = careComments;
        this.isPinned = isPinned;
    }

    static from(
        id: CareCommentThreadId,
        careRecipientId: CareRecipientId,
        createdTime: DateTime,
        careComments: CareComment[],
        isPinned: boolean
    ): CareCommentThread {
        return new CareCommentThread(id, careRecipientId, createdTime, careComments, isPinned);
    }
}

export type CareCommentThreadJson = {
    id: string,
    careRecipientId: string,
    createdTime: string,
    careCommentList: {
        id: string,
        title: string,
        content: string,
        createdTime: string,
        isRead: boolean
    }[],
    isPinned: boolean
};
